import { signIn } from './auth';
import { supabase } from './supabase';

export interface ExecutiveAuthResult {
  success: boolean;
  error?: string;
}

/**
 * Signs in with executive credentials and checks permissions
 */
export const signInAsExecutive = async (): Promise<ExecutiveAuthResult> => {
  try {
    // Sign in with executive account
    const result = await signIn('hamza@avnearth.com', 'AVNhamza2025!');
    
    if (!result.success) {
      throw new Error(result.error || 'Executive login failed');
    }
    
    // Verify this is an executive account
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('No user found after login');
    }
    
    // Check if user is an executive (CEO or specific admin)
    const isExecutive = 
      user.email === 'hamza@avnearth.com' || 
      user.email === 'watershedwisdomcouncils@gmail.com';
    
    if (!isExecutive) {
      await supabase.auth.signOut();
      throw new Error('Not authorized as executive');
    }
    
    return { success: true };
  } catch (error: any) {
    console.error('Executive auth error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Check if current user has executive privileges
 */
export const checkExecutiveAccess = async (): Promise<boolean> => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return false;
    
    // Check if user is an executive
    return (
      user.email === 'hamza@avnearth.com' || 
      user.email === 'watershedwisdomcouncils@gmail.com'
    );
  } catch (error) {
    console.error('Executive access check error:', error);
    return false;
  }
};